import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, verticalOffset, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '12.5 12'
  const rightTransformOrigin = '41.5 12'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M1.75151 6.47141C1.75151 6.47141 3.69549 2.03874 12.1459 1.0688C18.7217 0.312251 22.5998 6.04458 22.5998 6.04458L25 9.83706L0.263766 12C-0.549534 11.1174 0.680334 7.90692 1.75151 6.47141Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M1.77588 6.59521C1.77588 6.59521 11.8962 -3.81095 22.7759 6.14316C22.7759 6.14316 12.7654 -6.63584 1.77588 6.59521Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M52.2485 6.47141C52.2485 6.47141 50.3045 2.03874 41.8541 1.0688C35.2783 0.312251 31.4002 6.04458 31.4002 6.04458L29 9.83706L53.7362 12C54.5495 11.1174 53.3197 7.90692 52.2485 6.47141Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M52.2241 6.59521C52.2241 6.59521 42.1038 -3.81095 31.2241 6.14316C31.2241 6.14316 41.2346 -6.63584 52.2241 6.59521Z"
          fill={fill}
        />
      </g>
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="12.5001"
          y1="13.9023"
          x2="12.5001"
          y2="3.90619"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
          <stop offset="0.8775" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="41.4999"
          y1="13.9023"
          x2="41.4999"
          y2="3.90619"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
          <stop offset="0.8775" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
